<template>
    <div
        class="rounded-lg px-3 py-2 text-xs font-semibold uppercase tracking-wider text-gray-600"
        :class="classString"
    >
        {{ badge[1] }}
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
    badge: {
        type: Array,
        required: true
    }
})

const classString = computed(() => {
    if (props.badge[0] === 'GREEN') {
        return 'bg-emerald-300'
    } else if (props.badge[0] === 'RED') {
        return 'bg-red-300'
    } else if (props.badge[0] === 'YELLOW') {
        return 'bg-yellow-300'
    } else if (props.badge[0] === 'GRAY') {
        return 'bg-gray-300'
    } else if (props.badge[0] === 'BLUE') {
        return 'bg-blue-300'
    } else {
        throw new Error('Unknown contract state')
    }
})
</script>
